"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCommunityHomeAct = deleteCommunityHomeAct;
exports.getCommunityHomeActDetail = getCommunityHomeActDetail;
exports.getCommunityHomeActPage = getCommunityHomeActPage;
exports.homeActPreview = homeActPreview;
exports.saveCommunityHomeAct = saveCommunityHomeAct;
exports.updateCommunityHomeAct = updateCommunityHomeAct;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 分页查询装修-社区首页活动
 * @param {Object} params - 查询参数 {page, limit}
 * @returns {Promise}
 */
function getCommunityHomeActPage(params) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateCommunityHomeAct/page',
    method: 'get',
    params: params
  });
}

/**
 * 获取装修-社区首页活动详情
 * @param {Number} id - 活动ID
 * @returns {Promise}
 */
function getCommunityHomeActDetail(id) {
  return (0, _requestAuth.default)({
    url: "/xyDecorateCommunityHomeAct/".concat(id),
    method: 'get'
  });
}

/**
 * 保存装修-社区首页活动
 * @param {Object} data - 活动数据
 * @returns {Promise}
 */
function saveCommunityHomeAct(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateCommunityHomeAct',
    method: 'post',
    data: data
  });
}

/**
 * 修改装修-社区首页活动
 * @param {Object} data - 活动数据
 * @returns {Promise}
 */
function updateCommunityHomeAct(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateCommunityHomeAct',
    method: 'put',
    data: data
  });
}

/**
 * 删除装修-社区首页活动
 * @param {Number} id - 活动ID
 * @returns {Promise}
 */
function deleteCommunityHomeAct(id) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateCommunityHomeAct',
    method: 'delete',
    params: {
      id: id
    }
  });
}

/**
 * 社区首页活动预览
 * @param {Object} data - 预览数据 {ids, pageCode, optionCode, xcxType, pageURl}
 * @returns {Promise}
 */
function homeActPreview(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateCommunityHomeAct/homeActPreView',
    method: 'post',
    data: data
  });
}